const common = {
  actions: {
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    refresh: 'Refresh',
    retry: 'Retry',
    save: 'Save',
  },
  dialog: {
    close: 'Close dialog',
  },
  documentTitle: 'SpeedGauge Coach AI | Fleet Safety',
  dropdown: {
    clearSearch: 'Clear search',
    clearSearchText: 'Clear search text',
    noMatchingOptions: 'No matching options',
    searchLabel: 'Search {{label}}',
    searchPlaceholder: 'Search...',
  },
    header: {
      accountAndSettings: 'Account and settings',
      accountMenu: 'Account menu',
      adminDashboard: 'Admin dashboard',
      allVehicles: 'All vehicles',
      backToChat: 'Back to chat',
      closeSidebar: 'Close chat sidebar',
      customer: 'Customer:',
      loadingFleetList: 'Loading fleet list',
      loggingOut: 'Logging out...',
      newSession: 'New session',
      openSidebar: 'Open chat sidebar',
      returnToSafetyCenter: 'Return to Safety Center',
      selectCustomer: 'Select customer',
      selectVehicleGroup: 'Select vehicle group',
      vehicleGroup: 'Vehicle Group:',
    },
    sidebar: {
      ariaLabel: 'Chat sidebar',
      collapse: 'Collapse sidebar',
      coachSuggestions: 'Coach suggestions',
      guidedTours: 'Guided tours',
      help: 'Help',
      history: 'History',
      newSession: 'New session',
      newSessionTitle: 'New session (new chat)',
      recentChats: 'Recent chats',
      savedPrompts: 'Saved prompts',
      settings: 'Settings',
    },
  status: {
    loading: 'Loading...',
    noResults: 'No results found.',
    saving: 'Saving...',
  },
} as const;

export default common;